module.exports = __webpack_public_path__ + "static/media/contrast-w.26806364.svg";